// ==========================================
// Store pour les stats en ligne
// ==========================================

import { create } from 'zustand';

interface OnlineState {
  onlineCount: number;
  activeGamesCount: number;
  setOnlineCount: (count: number) => void;
  setActiveGamesCount: (count: number) => void;
}

export const useOnlineStore = create<OnlineState>((set) => ({
  onlineCount: 0,
  activeGamesCount: 0,
  setOnlineCount: (count) => set({ onlineCount: count }),
  setActiveGamesCount: (count) => set({ activeGamesCount: count }),
}));
